import { AxiosResponse } from "axios";
import API from "../api";
import { Sales } from "../models/sales";

const endpoint = "/jobs/estimate/customers";

const JobEstimateCustomerService = {
  async sendLinkToCustomer(jobId: number) {
    return await API.get(`${endpoint}/share/${jobId}`);
  },
  async getExternalData(token: string): Promise<AxiosResponse<Sales>> {
    return await API.get(`${endpoint}/external?token=${token}`);
  },
  async approveEstimate(data: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}/approve`, data);
  },
  async declineEstimate(data: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}/decline`, data);
  },
  async sendToReview(data: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}/review`, data);
  },
  async requestNewEstimateLink(data: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}/request/link`, data);
  },
};

export default JobEstimateCustomerService;
